import { render, staticRenderFns } from "./RenunganLanding.vue?vue&type=template&id=2340de8b&scoped=true&"
import script from "./RenunganLanding.vue?vue&type=script&lang=js&"
export * from "./RenunganLanding.vue?vue&type=script&lang=js&"
import style0 from "./RenunganLanding.vue?vue&type=style&index=0&id=2340de8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340de8b",
  null
  
)

export default component.exports